








































import { Component, Vue, Prop, Ref } from 'vue-property-decorator';
import { mapState } from 'vuex';

@Component({
  computed: {
    ...mapState({
      loading: 'loading',
    }),
  },
})
export default class QListItemExpand extends Vue {
  @Prop() readonly item!: Model;

  @Prop() readonly selected!: boolean;

  @Prop() readonly title!: string;

  @Prop() readonly subtitle!: string;

  @Prop({ default: 'Select item to make a booking' })
  readonly buttonDefaultLabel!: string;

  @Ref() readonly descEl!: HTMLDivElement;

  isCollapsed = true;

  replaceTagsToPTags(content) {
    // eslint-disable-next-line
    return content
      .replace(/<h\d>([\s\S]+?)<\/h\d>/gi, '<p>$1</p>')
      .replace(/<ul>([\s\S]+?)<\/ul>/gi, '<p>$1</p>')
      .replace(/<\/?(?!a)(?!p)(?!strong)\w*\b[^>]*>/gi, ' ');
  }

  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
    this.descEl.style.cssText = `--collapse-visible-height: ${this.descEl.scrollHeight}px`;
  }
}
